import { Injectable, PLATFORM_ID, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { Meta, Title, MetaDefinition } from '@angular/platform-browser';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { REQUEST } from 'angular-engine/modules/ng-express-engine/tokens';
import {APP_SETTINGS } from '../../../modules/ng-express-engine/tokens';
import { Angulartics2Vdgm } from 'angular-engine/engine/providers/Angulartics2Vdgm';

@Injectable()

export class MetaService {
 private metaTags : any;
 private isServer: boolean;
 private req : any;
 private tags : Array<string> =[
    'og:description',
    'og:title',
    'og:image',
    'og:video',
    'og:url',
    "og:video:width",
    "og:video:height",
    'twitter:player:stream',
    'twitter:card',
    'twitter:image',
    'twitter:site',
    'twitter:title',
    'twitter:description',
    "twitter:card"
 ]
 constructor (
        @Inject(PLATFORM_ID) platformId: string,
        @Inject(REQUEST) request: any,
        private meta : Meta,
        private title: Title,
        private router: Router,
        @Inject(APP_SETTINGS) private settings: Object,
        protected analytics: Angulartics2Vdgm
  ){
      this.isServer = isPlatformServer(platformId); 
      this.req = request;
  }

private setTags( metadata : any ) {
    let card : any = {};
    /*
    
    <meta class="swiftype" name="host" data-type="enum" content="https://www.nraila.org" />
    <meta class="swiftype" name="type" data-type="enum" content="article" />
    <meta class="swiftype" name="publicationdate" data-type="date" content="2018-02-02T21:03:27Z" />
    <meta class="swiftype" name="tags" data-type="string" content="News Articles" />
    <meta class="swiftype" name="tags" data-type="string" content="Federal Legislation" />
    <meta class="swiftype" name="tags" data-type="string" content="concealed carry" />
    <meta class="swiftype" name="tags" data-type="string" content="Reciprocity" />
    <meta class="swiftype" name="tags" data-type="string" content="Right-To-Carry" />
    <meta class="swiftype" name="tags" data-type="string" content="National Right-to-Carry Reciprocity Act" />
    <meta class="swiftype" name="tags" data-type="string" content="National Right-to-Carry Reciprocity Act" />
    <meta class="swiftype" name="image" data-type="enum" content="https://d97yz4wvpgciz.cloudfront.net/remote.axd?https://d3uwh8jpzww49g.cloudfront.net/sharedmedia/1509377/false.jpg?preset=article" />
    <meta class="swiftype" name="body" data-type="text" content="Anybody who is exposed to the so-called news media these days faces a barrage of bewildering and often outlandish claims. “Breaking news” cycles through the public eye with such frequency and speed that knowing what’s important, much less what’s true, is becoming increasingly difficult." />

    */
    this.metaTags = [
          {property:"og:url", content: this.settings['CLIENT_DOMAIN'] + (typeof metadata.urlOverride != "undefined" ? metadata.urlOverride : this.router.url) } as MetaDefinition,
          {property: "og:title"             , content: typeof metadata.title != "undefined" ? (this.settings['WEBSITE_TITLE'] + " | " + metadata.title) : ""} as MetaDefinition,
          {property: "og:description"       , content: typeof metadata.summary != "undefined" ? metadata.summary : ""} as MetaDefinition,
          {property: "og:image"             , content: this.hasImage(metadata.images) ? this.getImage(metadata) :  this.settings['CLIENT_DOMAIN'] + this.settings['DEFAULT_IMAGE']} as MetaDefinition,
          {property: "fb:app_id"            , content: this.settings['FACEBOOK_APP_ID']},
          {property: "fb:pages"             , content: this.settings['FACEBOOK_PAGE_ID']},
          {name: "twitter:image"            , content: this.hasImage(metadata.images) ? this.getImage(metadata) : this.settings['CLIENT_DOMAIN'] + this.settings['DEFAULT_IMAGE']} as MetaDefinition,
          {name: "twitter:site"             , content: "@" + this.settings['TWITTER_SITE'] } as MetaDefinition,
          {name: "twitter:title"            , content: typeof metadata.title != "undefined" ? (this.settings['WEBSITE_TITLE'] + " | " + metadata.title) : ""} as MetaDefinition,
          {name: "twitter:description"      , content: typeof metadata.stripped_description != "undefined" ? metadata.stripped_description : ""} as MetaDefinition ,
          {name: "description"              , content: typeof metadata.stripped_description != "undefined" ? metadata.stripped_description : ""} as MetaDefinition ,
          {class: "swiftype", name:"body", "data-type": "text", content: typeof metadata.stripped_description != "undefined" ? metadata.stripped_description : ""} as MetaDefinition,
          {class: "swiftype", name:"image", "data-type": "enum", content: this.hasImage(metadata.images) ? this.getImage(metadata) :  this.settings['CLIENT_DOMAIN'] + this.settings['DEFAULT_IMAGE']} as MetaDefinition,
          {class: "swiftype", name:"host", "data-type": "enum", content: this.settings['CLIENT_DOMAIN']} as MetaDefinition,

        ]
     
     if (metadata['obj_type']){
        if (metadata['obj_type'].toLowerCase() == "video" || metadata['obj_type'].toLowerCase() == "episode"){
            this.metaTags.push({name: "twitter:card", content: "player" } as MetaDefinition);
            this.metaTags.push({name: "twitter:player", content: this.settings['CLIENT_DOMAIN'] + "/embed" + this.req.path} as MetaDefinition);
            this.metaTags.push({name: "video:type", content: "video/mp4"} as MetaDefinition);
            this.metaTags.push({property: "og:video:type", content: "video/mp4"}  as MetaDefinition);
            this.metaTags.push({property: "og:video:width", content: "1920"}  as MetaDefinition);
            this.metaTags.push({property: "og:video:height", content:"1080"}  as MetaDefinition);
            this.metaTags.push({name: "twitter:player:width", content: "1920"}  as MetaDefinition);
            this.metaTags.push({name: "twitter:player:height", content:"1080"}  as MetaDefinition);
            this.metaTags.push({name: "twitter:player:stream:content_type", content:"video/mp4"}  as MetaDefinition);
            this.metaTags.push({class: "swiftype", name:"type", "data-type":"enum", content:"video"}  as MetaDefinition);
            
            if( metadata['obj_type'].toLowerCase() == "episode"){
                if(metadata.video)
                {
                    this.metaTags.push({property:"og:type", content: "video.episode"}  as MetaDefinition);
                    this.metaTags.push({property:"og:video", content: "https:" + metadata.video.meta.video_types[1].url} as MetaDefinition);
                    this.metaTags.push({property:"og:video:secure_url", content: "https:" + metadata.video.meta.video_types[1].url} as MetaDefinition);
                    this.metaTags.push({name: "twitter:player:stream",content: "https:" +  metadata.video.meta.video_types[1].url} as MetaDefinition);
                }
            }else{
                this.metaTags.push({property:"og:type", content: "video.other"}  as MetaDefinition);
                this.metaTags.push({property: "og:video", content: "https:" +  metadata.video_types[1].url} as MetaDefinition);
                this.metaTags.push({property: "og:video:secure_url", content: "https:" +  metadata.video_types[1].url} as MetaDefinition);
                this.metaTags.push({name: "twitter:player:stream", content: "https:" +  metadata.video_types[1].url} as MetaDefinition);
            }
        }else{
            this.metaTags.push({name: "twitter:card", content:"summary" });
            if(metadata['slug'] == 'home')
            {
                this.metaTags.push({class: "swiftype", name:"type", "data-type":"enum", content:"website"}  as MetaDefinition);
            }
            else
            {
                this.metaTags.push({class: "swiftype", name:"type", "data-type":"enum", content:"page"}  as MetaDefinition);
            }
            
        }
     }
  };

processMeta( metadata : any ): void{
    this.setTags( metadata  );
    this.meta.addTags( this.metaTags, true );

    this.title.setTitle( metadata.title + " | " +  this.settings['WEBSITE_TITLE']);
}


 setDynamicSearchTitle (title: any, uniqueId: string){
    this.title.setTitle( title + " | " +  this.settings['WEBSITE_TITLE']);
    
    if(this.settings['API_HEADERS']['X-PLATFORM'] !== "OTT")
    {
        this.analytics.pageTrack(this.router.url, uniqueId);
    }
 }

 private hasImage(images){
     if (images == null){
         return false;
     }
     if (Array.isArray(images)){
        if (images.length > 0){
            return true;
        }
        else{
            return false;
        }
     }
     else{
         return false;
     }
 }

 private getImage(metadata):string{
    let image:any;

    image = metadata.images.find((obj) => { 
        if(obj.name == 'thumb_1920x_header')
        {
            return true;
        }

        return false;
    });
    
    if(!image)
    {
        image = metadata.images.find((obj) => { 
            if(obj.name == 'thumb_1920x')
            {
                return true;
            }

            return false;
        });
    }

    return image.url;
 }
}


// WEBPACK FOOTER //
// ./src/angular-engine/engine/service/meta/meta.service.ts